"use client";

import { motion, type HTMLMotionProps } from "motion/react";
import { TRANSITION } from "./motion-tokens";

export interface StaggerProps extends HTMLMotionProps<"div"> {
  delay?: number;
  staggerDelay?: number;
}

export function Stagger({ delay = 0, staggerDelay = 0.05, children, ...props }: StaggerProps) {
  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={{
        visible: { transition: { staggerChildren: staggerDelay, delayChildren: delay } },
      }}
      {...props}
    >
      {children}
    </motion.div>
  );
}

export function StaggerItem(props: HTMLMotionProps<"div">) {
  return (
    <motion.div
      variants={{
        hidden: { opacity: 0, y: 8 },
        visible: { opacity: 1, y: 0, transition: TRANSITION.base },
      }}
      {...props}
    />
  );
}
